import React from 'react';
import './HeaderLeft.styl';

export default function HeaderLeft({
  title,
  description,
  image,
  imageClass,
  wrapperClass,
}) {
  return (
    <div
      className={`lg:grid lg:grid-cols-2 lg:gap-16 lg:min-h-[600px] items-center mb-12 bg-gold ${
        wrapperClass || ''
      }`}
    >
      <div className="max-width !py-3  !pt-0">
        <div className="globalNavOffset" />
        <div className="lg:w-[500px] max-w-full lg:pr-3 header-left-description">
          <h1 className="text-3xl !leading-[1.2] lg:text-5xl my-6">{title}</h1>
          {description && typeof description === 'string' ? (
            <p className="text-sm">{description}</p>
          ) : (
            description || null
          )}
          <div className="globalNavOffset" />
        </div>
      </div>
      <div
        className={`bg-gold h-full bg-cover bg-top  ${imageClass || ''}`}
        style={image ? { backgroundImage: `url(${image})` } : null}
      />
    </div>
  );
}
